import { FormFieldError } from './form-field-error'
import { Input, InputProps } from './input/input'
import * as React from 'react'
import { cn } from 'src/lib/utils'

export interface FieldProps extends Omit<InputProps, 'type' | 'value' | 'disabled' | 'readOnly' | 'placeholder' | 'variant'> {
  label: string
  name: string
  value?: string
  type?: 'text' | 'email' | 'password'
  placeholder?: string
  disabled?: boolean
  readOnly?: boolean
  error?: string
  className?: string
  inputClassName?: string
  hideLabel?: boolean
}

export const Field = React.forwardRef<HTMLInputElement, FieldProps>(
  (
    {
      label,
      name,
      value,
      type = 'text',
      placeholder,
      disabled,
      readOnly,
      error,
      className,
      inputClassName,
      hideLabel,
      onChange,
      ...inputProps
    },
    ref,
  ): React.ReactElement => {
    return (
      <div className={cn('space-y-2', className)}>
        <label htmlFor={name} className={cn('block text-sm font-roboto-condensed font-bold text-mist', hideLabel && 'sr-only')}>
          {label}
        </label>
        <Input
          ref={ref}
          id={name}
          name={name}
          type={type}
          value={value || ''}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          variant={error ? 'error' : 'default'}
          className={inputClassName}
          onChange={onChange}
          {...inputProps}
        />
        <FormFieldError>{error}</FormFieldError>
      </div>
    )
  },
)
Field.displayName = 'Field'
